import { UserStore } from './user/user.state';
import { QuizStore } from './quiz/quiz.state';
export const store = [
    QuizStore,
    UserStore
]